<template>
  <b-row v-if="isProfileLoaded">
    <b-col lg="4">
      <b-card class="card-custom gutter-b" no-body>
        <div class="card-header border-0 pt-5 pb-5">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label font-weight-bolder text-dark">
              {{ $t("messages.assets.titles.types") }}
            </span>
          </h3>
        </div>
        <div class="card-body pt-0 d-flex flex-wrap">
          <b-btn
            tag="a"
            variant="outline-light"
            class="mb-4 box-card btn-text"
            :class="{ active: isActive({ sub: 'type', id: type }) }"
            v-for="(total, type) in types"
            :key="type"
            @click="filter(type, 'type')"
            :set="(icon = getAssetIcon(type))"
          >
            <div class="mb-3 text-center w-100">
              <span class="svg-icon svg-icon-4x" v-if="icon.image">
                <simple-svg
                  :src="require(`@/assets/images/icons/${icon.image}`)"
                />
              </span>
              <i :class="`${icon.class} icon-3x p-0`" v-else-if="icon.class" />
              <span
                v-else-if="icon.file"
                class="svg-icon svg-icon-4x align-self-center"
                style="margin-top: -10px; display: block"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 324 119" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#E62B1E" d="M32.678 30.831H0V.85h101.56v29.981H68.875V118.3H32.678V30.831zM107.18.85h98.75v29.981h-62.55v14.462h62.55v28.212h-62.55v14.814h62.55V118.3h-98.75V.85zm104.72 0h59.39C310.3.85 324 29.773 324 59.401c0 35.975-18.98 58.899-59.74 58.899H211.9V.85zm36.2 87.469h14.05c22.49 0 25.66-18.337 25.66-29.27 0-7.41-2.46-27.865-28.47-27.865h-11.6l.36 57.135z"/></svg>
              </span>
            </div>
            <span
              class="nav-text font-size-lg pt-1 font-weight-bolder text-center text-dark-75"
            >
              {{ $tc(`messages.assets.buttons.${type}`) }}
              <div class="text-muted pt-2">
                {{
                  $tc("messages.assets.buttons.folders", total, {
                    total: total
                  })
                }}
              </div>
            </span>
          </b-btn>
        </div>
      </b-card>
      <b-card class="card-custom gutter-b" no-body>
        <div class="card-header border-0 pt-5 pb-5">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label font-weight-bolder text-dark">
              {{ $t("messages.assets.titles.folders") }}
            </span>
          </h3>
        </div>
        <div class="card-body pt-0 d-flex flex-wrap">
          <b-btn
            tag="a"
            variant="outline-light"
            class="mb-4 box-card btn-text"
            :class="{ active: isActive({ sub: 'family', id: tab.id }) }"
            v-for="tab in families"
            :key="tab.id"
            @click="filter(tab.id, 'family')"
          >
            <span class="mb-3">
              <span class="svg-icon svg-icon-4x svg-icon-tc6" v-if="tab.image">
                <simple-svg
                  :src="require(`@/assets/images/icons/${tab.image}`)"
                />
              </span>
              <span class="icon-3x icon-success" v-else>
                <i :class="tab.icon"></i>
              </span>
            </span>
            <div
              class="nav-text font-size-sm pt-1 font-weight-bolder text-center text-dark-75 w-100"
            >
              {{ tab.title }}
              <div class="text-muted pt-2">
                {{
                  $tc("messages.assets.buttons.folders", tab.total, {
                    total: tab.total
                  })
                }}
              </div>
            </div>
          </b-btn>
        </div>
      </b-card>
    </b-col>
    <b-col lg="8" md="12">
      <b-card class="card-custom gutter-b pb-0 pt-3 cardround" no-body>
        <div class="card-body d-flex flex-wrap py-1">
          <b-btn
            tag="a"
            variant="outline-light"
            class="mb-4 box-card btn-text"
            :class="{ active: isActive({ sub: 'status', id: tab.id }) }"
            v-for="tab in assetStatus"
            :key="tab.id"
            @click="filter(tab.id, 'status', 'or')"
            style="width: 20%; margin-right: 2.5%; margin-left: 2.5%"
          >
            <div class="pb-1">
              <span class="svg-icon svg-icon-4x" v-if="tab.image">
                <simple-svg
                  :src="require(`@/assets/images/icons/${tab.image}`)"
                />
              </span>
              <div class="w-100" v-else>
                <i :class="tab.icon"></i>
              </div>
            </div>
            <span
              class="nav-text font-size-lg pt-2 font-weight-bolder text-center text-dark-75"
            >
              {{ tab.title }}
              <div class="text-muted pt-1">
                {{
                  $tc("messages.assets.buttons.folders", tab.total, {
                    total: tab.total
                  })
                }}
              </div>
            </span>
          </b-btn>
          <b-btn
            tag="a"
            variant="outline-light"
            class="mb-4 box-card btn-text"
            :class="{ active: isActive({ sub: 'priority', id: tab.id }) }"
            v-for="tab in priorities"
            :key="tab.id"
            @click="filter(tab.id, 'priority', 'or')"
            style="width: 20%; margin-right: 2.5%; margin-left: 2.5%"
          >
            <div class="pb-1">
              <span class="svg-icon svg-icon-4x" v-if="tab.image">
                <simple-svg
                  :src="require(`@/assets/images/icons/${tab.image}`)"
                />
              </span>
              <div class="w-100" v-else>
                <i :class="tab.icon"></i>
              </div>
            </div>
            <span
              class="nav-text font-size-lg pt-2 font-weight-bolder text-center text-dark-75"
            >
              {{ tab.title }}
              <div class="text-muted pt-1">
                {{
                  $tc("messages.assets.buttons.folders", tab.total, {
                    total: tab.total
                  })
                }}
              </div>
            </span>
          </b-btn>
        </div>
      </b-card>
      <b-card class="card-custom gutter-b" no-body>
        <div class="card-header border-0 pt-5 pb-0 min-h-50px">
          <h3 class="card-title align-items-start flex-column mb-0">
            <span class="card-label font-weight-bolder text-dark">
              {{ $t("messages.assets.titles.files") }}
            </span>
          </h3>
        </div>
        <b-card-body class="pt-0">
          <b-table
            class="pt-0 mt-0"
            id="assets-table"
            :items="filtered"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            primary-key="assetId"
            :responsive="true"
            show-empty
            :borderless="true"
            :small="true"
            sort-icon-left
          >
            <template #cell(link)="row">
              <div
                class="symbol symbol-50 symbol-light mr-5"
                :set="(icon = getAssetIcon(row.item.type))"
              >
                <div class="symbol-label">
                  <span v-if="icon.class" class="align-self-center">
                    <i :class="`${icon.class} icon-xl`" />
                  </span>
                  <span
                    v-else-if="icon.image"
                    class="svg-icon svg-icon-xl align-self-center"
                  >
                    <simple-svg
                      :src="require(`@/assets/images/icons/${icon.image}`)"
                      class="h-50 w-50"
                    />
                  </span>
                  <span
                    v-else-if="icon.file"
                    class="svg-icon svg-icon-lg align-self-center"
                  >
                    <img src="@/assets/images/files/ted.svg" class="w-25px" />
                  </span>
                </div>
              </div>
              <div class="d-flex flex-column flex-grow-1 mr-2 my-2">
                <div
                  href="#"
                  class="font-weight-bold text-dark-75 font-size-lg mb-1"
                >
                  {{ row.value }}
                </div>
              </div>
            </template>
            <template #cell(assetCount)="row">
              <i class="la la-star-o text-warning icon-2x" v-if="row.value" />
              <i class="la la-trophy text-warning icon-2x" v-else />
            </template>
            <template #cell(totalReaded)="row">
              <i class="la la-eye text-success icon-2x" v-if="row.value > 0" />
              <i class="la la-eye-slash text-danger icon-2x" v-else />
            </template>
            <template #cell(actions)="row">
              <b-btn
                class="btn-icon svg-icon svg-icon-lg align-self-center"
                variant="light"
                @click="downloadFile(row.item)"
              >
                <img src="@/assets/images/icons/search.svg" />
              </b-btn>
            </template>
          </b-table>
          <div class="flex-wrap mx-auto" v-if="total > 0">
            <b-pagination
              class="custom-pagination"
              v-model="currentPage"
              :total-rows="total"
              :per-page="perPage"
              aria-controls="assets-table"
              first-number
              last-number
              align="center"
              size="md"
            >
              <template #first-text>
                <i class="ki ki-bold-double-arrow-back icon-xs"></i>
              </template>
              <template #prev-text>
                <i class="ki ki-bold-arrow-back icon-xs"></i>
              </template>
              <template #next-text>
                <i class="ki ki-bold-arrow-next icon-xs"></i>
              </template>
              <template #last-text>
                <i class="ki ki-bold-double-arrow-next icon-xs"></i>
              </template>
            </b-pagination>
          </div>
        </b-card-body>
      </b-card>
    </b-col>
    <pdf
      :v-if="showPdf"
      :base64="showingAsset"
      :showAsset="showPdf"
      :name="pdfName"
      @asset-closed="showPdf = false"
    />
    <b-modal
      v-model="showed"
      size="xl"
      id="asset-modal"
      @hidden="showed = false"
      :cancel-disabled="true"
    >
      <Youtube v-if="Object.keys(youtube).length > 0" :code="youtube.content" />
      <Ted v-if="Object.keys(ted).length > 0" :code="ted.content" />
      <Vimeo v-if="Object.keys(vimeo).length > 0" :code="vimeo.content" />
      <Iframe v-if="Object.keys(iframe).length > 0" :code="iframe.content" />
      <template #modal-footer="{ ok }">
        <b-button size="md" pill variant="secondary" @click="ok()">
          OK
        </b-button>
      </template>
    </b-modal>
  </b-row>
</template>

<script>
import _ from "lodash";

import Pdf from "@/components/assets/Pdf.component";
import Youtube from "@/components/assets/Youtube.component";
import Ted from "@/components/assets/Ted.component";
import Vimeo from "@/components/assets/Vimeo.component";
import Iframe from "@/components/assets/Iframe.component";

import { mapGetters, mapActions } from "vuex";
import { SimpleSVG } from "vue-simple-svg";

export default {
  name: "Assets",
  components: {
    "simple-svg": SimpleSVG,
    Pdf,
    Youtube,
    Ted,
    Vimeo,
    Iframe
  },
  data() {
    return {
      activeFilters: {
        type: [],
        family: [],
        status: [],
        priority: []
      },
      perPage: 10,
      currentPage: 1,
      showingAsset: "",
      showPdf: false,
      showed: false,
      pdfName: "Kymatio.pdf",
      youtube: {},
      ted: {},
      vimeo: {},
      iframe: {}
    };
  },
  computed: {
    ...mapGetters("Profile", ["assets", "isProfileLoaded"]),
    isActive() {
      return params => _.includes(this.activeFilters[params.sub], params.id);
    },
    types() {
      return _.countBy(this.assets, "type");
    },
    families() {
      var families = _.countBy(this.assets, "family");
      var result = [];
      _.each(families, (total, family) => {
        result.push({
          id: family,
          title: this.$t(`messages.assets.buttons.${family}`),
          image: "folder.svg",
          total: total || 0
        });
      });
      return result;
    },
    priorities() {
      var counters = _.countBy(this.assets, "assetCount");
      return [
        {
          id: "priority",
          title: this.$t("messages.assets.table.rows.priority"),
          total: counters["2"] || 0,
          icon: "text-warning icon-2x la la-star-o"
        },
        {
          id: "nopriority",
          title: this.$t("messages.assets.table.rows.nopriority"),
          total: counters["1"] || 0,
          icon: "text-warning icon-2x la la-trophy"
        }
      ];
    },
    assetStatus() {
      var counters = _.countBy(this.assets, asset => asset.totalReaded > 0);
      return [
        {
          id: "readed",
          title: this.$tc(`messages.assets.buttons.readed`, counters.true || 0),
          icon: "la la-eye text-success icon-2x",
          total: counters.true || 0
        },
        {
          id: "unreaded",
          title: this.$tc(
            `messages.assets.buttons.unreaded`,
            counters.false || 0
          ),
          icon: "la la-eye-slash text-danger icon-2x",
          total: counters.false || 0
        }
      ];
    },
    fields() {
      return [
        {
          key: "link",
          label: this.$t("messages.assets.table.link"),
          sortable: true,
          sortDirection: "desc",
          class:
            "font-weight-bold text-left align-middle d-flex align-items-center flex-wrap mb-3",
          thClass: "h6"
        },
        {
          key: "family",
          label: this.$t("messages.assets.table.family"),
          formatter: value => this.$t(`messages.assets.buttons.${value}`),
          sortByFormatted: true,
          filterByFormatted: true,
          sortable: true,
          sortDirection: "desc",
          class: "font-weight-bold text-left align-middle",
          thClass: "h6"
        },
        {
          key: "assetCount",
          label: this.$t("messages.assets.table.assetCount"),
          sortable: true,
          sortDirection: "desc",
          formatter: value => (parseInt(value) === 1 ? false : true),
          sortByFormatted: true,
          filterByFormatted: true,
          class: "font-weight-bold align-middle",
          thClass: "h6 text-left"
        },
        {
          key: "totalReaded",
          label: this.$t("messages.assets.table.totalReaded"),
          sortable: true,
          sortDirection: "desc",
          formatter: value => (value > 0 ? 1 : 0),
          sortByFormatted: true,
          filterByFormatted: true,
          class: "font-weight-bold align-middle",
          thClass: "h6 text-left"
        },
        {
          key: "actions",
          label: this.$t("messages.assets.table.actions"),
          class: "font-weight-bold text-left align-middle"
        }
      ];
    },
    filtered() {
      var assets = this.assets;
      if (this.activeFilters.family.length > 0) {
        assets = _.filter(assets, asset =>
          _.includes(this.activeFilters.family, asset.family)
        );
      }
      if (this.activeFilters.type.length > 0) {
        assets = _.filter(assets, asset =>
          _.includes(this.activeFilters.type, asset.type)
        );
      }
      if (this.activeFilters.status.length > 0) {
        if (_.includes(this.activeFilters.status, "readed")) {
          assets = _.filter(assets, asset => parseInt(asset.totalReaded) > 0);
        }
        if (_.includes(this.activeFilters.status, "unreaded")) {
          assets = _.filter(assets, asset => parseInt(asset.totalReaded) === 0);
        }
      }
      if (this.activeFilters.priority.length > 0) {
        if (_.includes(this.activeFilters.priority, "nopriority")) {
          assets = _.filter(assets, asset => parseInt(asset.assetCount) === 1);
        }
        if (_.includes(this.activeFilters.priority, "priority")) {
          assets = _.filter(assets, asset => parseInt(asset.assetCount) === 2);
        }
      }
      return assets;
    },
    total() {
      return this.filtered.length;
    },
    ...mapGetters("Constants", ["isConstantsActive"])
  },
  methods: {
    ...mapActions("Profile", ["loadProfile", "reloadAssets"]),
    filter(id, type, cond = "and") {
      if (cond === "and") {
        _.includes(this.activeFilters[type], id)
          ? (this.activeFilters[type] = _.reject(
              this.activeFilters[type],
              el => el === id
            ))
          : this.activeFilters[type].push(id);
      } else {
        _.includes(this.activeFilters[type], id)
          ? (this.activeFilters[type] = _.reject(
              this.activeFilters[type],
              el => el === id
            ))
          : (this.activeFilters[type] = [id]);
      }
    },
    getAssetIcon(type) {
      var result = {};
      switch (type) {
        case "youtube_iframe":
          result.class = "socicon-youtube text-danger";
          break;
        case "ted_iframe":
          result.file = "files/ted.svg";
          break;
        case "vimeo_iframe":
          result.class = "socicon-vimeo text-danger";
          break;
        case "iframe":
          result.image = "video-camera.svg";
          break;
        case "audea_link":
          result.image = "warning-circle.svg";
          break;
        default:
          result.class = `fas fa-file-${type}`;
          break;
      }
      return result;
    },
    downloadFile(asset, automatic = true) {
      this.ted = {};
      this.youtube = {};
      this.vimeo = {};
      this.iframe = {};
      this.axios
        .get(asset.url)
        .then(response => {
          if (automatic) {
            if (
              response.data.records.forward &&
              asset.type !== "youtube_iframe" &&
              asset.type !== "ted_iframe" &&
              asset.type !== "vimeo_iframe" &&
              asset.type !== "iframe"
            ) {
              let a = document.createElement("a");
              a.href = response.data.records.content;
              a.target = "_blank";
              a.click();
            } else {
              if (asset.type === "pdf") {
                this.showingAsset = response.data.records.content;
                this.showPdf = true;
                this.pdfName = asset.link;
              } else if (asset.type === "youtube_iframe") {
                this.youtube = response.data.records;
                this.showed = true;
              } else if (asset.type === "ted_iframe") {
                this.ted = response.data.records;
                this.showed = true;
              } else if (asset.type === "vimeo_iframe") {
                this.vimeo = response.data.records;
                this.showed = true;
              } else if (asset.type === "iframe") {
                this.iframe = response.data.records;
                this.showed = true;
              } else {
                return response.data.records;
              }
            }
          } else {
            return response.data.records.content;
          }
          this.reloadAssets();
        })
        .catch(error => {
          if (error.response.status === 412) {
            this.$swal(
              this.$t("messages.generic.errors.fileNotFound"),
              "",
              "error"
            );
          }
        });
    }
  },
  mounted() {
    if (this.isConstantsActive && !this.isProfileLoaded) this.loadProfile();
    if (this.$route.params.status)
      this.activeFilters.status = [this.$route.params.status];
    if (this.$route.params.family)
      this.activeFilters.family = [this.$route.params.family];
    if (this.$route.params.priority)
      this.activeFilters.priority = [this.$route.params.priority];
  },
  watch: {
    isConstantsActive(value) {
      if (value === true) this.loadProfile();
    }
  }
};
</script>

<style lang="scss">
.nav.nav-pills.nav-secondary .show > .nav-link,
.nav.nav-pills.nav-secondary .nav-link:hover:not(.active) {
  color: #464e5f !important;
}
.btn.box-card {
  width: 30%;
  margin-right: 3%;
}

.table.b-table > thead > tr > [aria-sort].b-table-sort-icon-left,
.table.b-table > tfoot > tr > [aria-sort].b-table-sort-icon-left {
  padding-left: calc(0.75rem + 0.65em) !important;
}

.custom-pagination {
  li.page-item,
  li.page-item.disabled {
    margin: 0.25rem 0.5rem 0.25rem 0rem !important;
    button,
    span {
      outline: none !important;
      vertical-align: middle;
      -webkit-transition: color 0.15s ease, background-color 0.15s ease,
        border-color 0.15s ease, -webkit-box-shadow 0.15s ease;
      transition: color 0.15s ease, background-color 0.15s ease,
        border-color 0.15s ease, -webkit-box-shadow 0.15s ease;
      transition: color 0.15s ease, background-color 0.15s ease,
        border-color 0.15s ease, box-shadow 0.15s ease;
      transition: color 0.15s ease, background-color 0.15s ease,
        border-color 0.15s ease, box-shadow 0.15s ease,
        -webkit-box-shadow 0.15s ease;
      display: inline-flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      padding: 0;
      background-color: #f3f6f9;
      border-color: #f3f6f9;
      color: #7e8299;
      height: calc(1.35em + 1.1rem + 2px);
      width: calc(1.35em + 1.1rem + 2px);
      i {
        color: #7e8299;
      }
    }

    &.active > button,
    &.active > span {
      font-weight: bold;
      i {
        color: #282a35 !important;
      }
      color: #282a35 !important;
      background-color: #cccfdc !important;
      border-color: #e4e6ef !important;
    }
    &.disabled > button,
    &.disabled > span {
      i {
        color: #d9ddeb !important;
      }
      background-color: #f3f6f9 !important;
      border-color: #f3f6f9 !important;
    }
  }
}
</style>
